import { createSelector } from 'reselect';
import { reduxKey } from '../constants';
export function getStoreSlice(state) {
    if (!state[reduxKey]) {
        return {};
    }
    return state[reduxKey]['editor'];
}
export const getMenuUpdate = createSelector(getStoreSlice, (state)=>{
    return state.menuUpdates;
});
export const isMuroOpen = createSelector(getStoreSlice, (state)=>{
    return state.muroOpen;
});
export const getMuroProps = createSelector(getStoreSlice, (state)=>{
    return state.muroProps;
});

//# sourceMappingURL=editor.js.map